import React from 'react';
import styled from 'styled-components';
import Skeleton from '@pedidosya/web-fenix/system/Skeleton';

const Container = styled.div`
  padding-left: 12px;
  display: flex;
  align-items: center;
  padding-bottom: 12px;
  width: 100%;
  gap: 8px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

function ReviewsCardShimmer() {
  return (
    <Container>
      <Skeleton height="20" width="20" />
      <Content>
        <Skeleton height="5" width="28" />
        <Skeleton height="5" width="20" />
      </Content>
    </Container>
  );
}

export default ReviewsCardShimmer;
